import NavigableValidation from "./navigableValidation";
import CertificateElement from "../../../formability/certificateBuilder/models/certificateElement";
import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import {ErrorType} from "~/enums/ErrorType"
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import BaseCertificateElement from "../../../formability/certificateBuilder/models/baseCertificateElement";

export default class CertificateElementValidation extends NavigableValidation<BaseCertificateElement> {
  validators = [
    new FieldPresenceValidator({
      validatorKey: 'client_id',
      section: ValidationModalSection.Layout,
    }),
    new FieldPresenceValidator({
      validatorKey: "underlying_variable",
      displayName: "Underlying Variable",
      section: ValidationModalSection.Layout,
      type: ErrorType.mustBeConfigured,
      message: "Dynamic signature/image must be configured",
      conditional: (model, key) => {
        return ["Dynamic Image", "Dynamic Signature", "Dynamic Mode Dynamic Signature"].includes(this.model["type"])
      }
    }),
    new FieldPresenceValidator({
      validatorKey: "dynamic_list_client_id",
      displayName: "Dynamic List",
      section: ValidationModalSection.Layout,
      type: ErrorType.mustBeConfigured,
      message: "Dynamic list must be configured",
      conditional: (model, key) => {
        return this.model["type"] === "Dynamic List";
      }
    })
  ];

  protected buildQuery(validatorKey): {} {
    return {
      underlying_variable: this.model.client_id,
      certificateElementId: this.model.client_id
    }
  }
}